
import i18n from '@/i18n.js'
import RegulatoryDamageService from '../services/regulatory_damage.service';
export default {
    namespaced: true,
    state: () => ({
    }),
    actions: {

        add_damage({ rootState }, data) {
            data.append('status', data.get('status_damage') == "true" ? 1 : 0)
            return RegulatoryDamageService.add(data).then(
                (response) => {
                    console.log(response);
                    rootState.form.loader = false;
                    // rootState.form.dialog = false
                    rootState.form.notify = {
                        msg: response.data.message,
                        type: "Success",
                    };
                    setTimeout(function () {
                        window.location.reload()
                    }, 1200);
                },
                (error) => {
                    console.log(error);
                    rootState.form.loader = false;
                    if (error.response.status == 422) {
                        var errors = error.response.data.errors;
                        for (
                            let i = 0;
                            i < rootState.form.style_form.length;
                            i++
                        ) {
                            const element = rootState.form.style_form[i];
                            element.error = errors[element.value_text];
                        }
                    } else if (error.response.status != 401) {
                        rootState.form.notify = {
                            msg: i18n.t("general.there is problem"),
                            type: "Danger",
                        };
                    }
                }
            );

        },
        edit_damage({ rootState }, data) {
            data.append('status', data.get('status_damage') == "true" ? 1 : 0)
            return RegulatoryDamageService.edit(rootState.id, data).then(
                (response) => {
                    console.log(response);
                    rootState.form.loader = false;
                    rootState.form.notify = {
                        msg: response.data.message,
                        type: "Success",
                    };
                    setTimeout(function () {
                        window.location.reload()
                    }, 1200);
                },
                (error) => {
                    console.log(error);
                    rootState.form.loader = false;
                    if (error.response.status == 422) {
                        var errors = error.response.data.errors;
                        for (
                            let i = 0;
                            i < rootState.form.style_form.length;
                            i++
                        ) {
                            const element = rootState.form.style_form[i];
                            element.error = errors[element.value_text];
                        }
                    } else if (error.response.status != 401) {
                        rootState.form.notify = {
                            msg: i18n.t("general.there is problem"),
                            type: "Danger",
                        };
                    }
                }
            );

        },


    }
};